import createCurriculumMutation from '../mutations/CreateCurriculum.gql'
import fetchCurriculums from '../queries/FetchCurriculums.gql'
import uuid from 'uuid/v4'

export default function (variables) {
  variables['uuid'] = uuid()
  return {
    mutation: createCurriculumMutation,
    variables: variables,
    refetchQueries: [
      {
        query: fetchCurriculums,
      },
    ],
  }
}
